<template>
  <div class="containerTable" style="padding: 15px;">
    <vxe-toolbar
      v-if="getLimit('print_search_button')"
      id="toolbarId_sy1"
      :custom="{storage: true}"
      export
      :buttons="toolbarButtons"
      :refresh="{query: RefreshList}"
    />
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :footer-method="footerMethod"
      :checkbox-config="{highlight: true}"
      :loading="loading"
      :data="tableData"
    >
      <vxe-table-column
        type="checkbox"
        width="60"
        fixed="left"
      />
      <vxe-table-column>
        <vxe-table-column
          field="reviewer"
          title="打印机名称"
          min-width="100"
          sortable
        />
        <template v-slot:header="{ column }">
          <el-input
            v-model="message"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="类型"
          min-width="100"
          sortable
        />
        <template v-slot:header="{ column }">
          <el-input
            v-model="message"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="reviewer"
          title="IP地址"
          min-width="100"
          sortable
        />
        <template v-slot:header="{ column }">
          <el-input
            v-model="message"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="备注"
          min-width="100"
          sortable
        />
        <template v-slot:header="{ column }">
          <el-input
            v-model="message"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          
          title="操作"
          min-width="100"
          fixed="right"
        />
        <template>
          <el-tooltip
            v-if="getLimit('print_edit_button')"
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button type="text">
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('print_delete_button')"
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <vxe-button type="text">
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.page"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.limit"
      :total="listQuery.totalzong"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />
  </div>
</template>
<script>
import { fetchList } from '@/api/article'
export default {
  data() {
    return {
      message: '',
      loading: false,
      tableData: [],
      listQuery: {
        page: 1,
        limit: 13,
        totalzong: 0
      },
      Pagingconf: [],
      toolbarButtons: [
        {
          code: 'btn1',
          name: '查询'
        }
      ]
    }
  },
  created() {
    this.findList()
  },
  methods: {
    findList() {
      this.loading = true
      fetchList(this.listQuery).then(response => {
        this.tableData = response.data.items
        this.listQuery.totalzong = response.data.total
          response.data.total>10000? this.Pagingconf = [20, 30, 50, 100,10000]:this.Pagingconf = [20, 30, 50, 100, response.data.total || 1];
        this.loading = false
      })
    },

    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.page = currentPage
      this.listQuery.limit = pageSize
      this.findList()
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return '平均'
          }
          if (['pageviews', 'forecast'].includes(column.property)) {
            return this.$XEUtils.mean(data, column.property)
          }
          return null
        }),
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return '和值'
          }
          if (['pageviews', 'forecast'].includes(column.property)) {
            return this.$XEUtils.sum(data, column.property)
          }
          return null
        })
      ]
    }
  }
}
</script>

<style>

</style>
